<template>
  <div
    :id="kebabName"
    class="shipment-card position-relative"
  >
    <div
      class="shipment-card-title"
    >
      <slot name="title"></slot>
    </div>
    <b-collapse
      :id="kebabName + '-body'"
      :visible="visible"
      class="shipment-card-body"
    >
      <div class="pt-3">
        <slot name="body"></slot>
      </div>
    </b-collapse>
  </div>
</template>

<script>
const kebabCase = require('lodash/kebabCase');

export default {
  name: 'CustomerPrototypeCard',
  props: {
    name: {
      required: true,
      type: String,
    },
    collapsible: {
      required: false,
      type: Boolean,
      default: true,
    },
    visible: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  computed: {
    kebabName() {
      return kebabCase(this.name);
    },
  },
};
</script>

<style scoped>
.shipment-card {
  background: white;
  border-radius: 5px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  padding: 15px 0;
  margin-bottom: 15px;
}

.shipment-card-title {
  outline: none;
}

.shipment-card-title.collapsible::after {
  display: block;
  position: absolute;
  top: 1.4em;
  right: 20px;
  transition: all .25s ease-out;
  transform: scaleY(1);
}

.shipment-card-title.not-collapsed::after {
  transition: all .25s ease-out;
  transform: scaleY(-1);
}
</style>
